<template>
  <button class="social-size" :class="socialMedia" @click="openNewTab(socialMedia)"></button>
  <!-- <div class="social-size" :class="socialMedia" /> -->
  <!-- <a class="btn" style="border-color:#4267B2" href="https://twitter.com/intent/tweet?text=www.whodrinks.com #WhoDrinks"> -->
</template>
<script>
export default {
  name: "share-icon",
  props: {
    socialMedia: {
      type: String,
      default: "", // facebook, whatsapp, twitter
    },
  },
  data() {
    return {
      urlToOpen: {
        whatsapp: "whatsapp://send?text=The text to share!",
        twitter:
          "https://twitter.com/intent/tweet?text=www.whodrinks.com %23WhoDrinks",
        facebook: 3,
        title: "Why Vue is so fun",
      },
    };
  },
  methods: {
    openNewTab(socialMedia) {
      window.open(this.urlToOpen[socialMedia]);
    },
  },
};
</script>
<style>
.facebook {
  background: url(../../../public/img/icons/facebook-icon.svg);
}
.whatsapp {
  background: url(../../../public/img/icons/whatsapp-icon.svg);
}
.twitter {
  background: url(../../../public/img/icons/twitter-icon.svg);
}

.social-size {
  border: 0;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  width: 48px;
  height: 48px;
}
</style>
